import { createFileRoute, Link } from "@tanstack/react-router";
import { useState } from "react";
import { z } from "zod";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { searchPlaybook } from "@/lib/playbook-content";

export const Route = createFileRoute("/_authenticated/app/playbook/search")({
  component: PlaybookSearch,
  validateSearch: z.object({ q: z.string().optional() }),
});

function PlaybookSearch() {
  const { q: qParam } = Route.useSearch();
  const [q, setQ] = useState(qParam ?? "");
  const hits = q.trim() ? searchPlaybook(q, 50) : [];

  return (
    <div className="p-4 sm:p-6 max-w-3xl mx-auto space-y-6">
      <div className="relative">
        <Search className="absolute left-3 top-3 h-4 w-4 text-muted-foreground" />
        <Input
          autoFocus
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search the Playbook…"
          className="pl-9 h-11"
        />
      </div>
      <div className="space-y-2">
        {hits.map((h) => (
          <Link
            key={h.slug}
            to="/app/playbook/$"
            params={{ _splat: h.slug }}
            className="block p-3 rounded-md border hover:bg-accent"
          >
            <div className="flex items-center justify-between">
              <div className="font-medium text-sm">{h.title}</div>
              <span className="text-[10px] uppercase text-muted-foreground">{h.section}</span>
            </div>
            <div className="text-xs text-muted-foreground mt-1 line-clamp-2">{h.excerpt}</div>
          </Link>
        ))}
        {q.trim() && hits.length === 0 && <div className="text-sm text-muted-foreground">No results.</div>}
      </div>
    </div>
  );
}